var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLounge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.623 40H10.663C10.331 40 10.091 39.682 10.182 39.363L11.896 33.363C11.958 33.148 12.154 33 12.377 33H15.337C15.669 33 15.909 33.318 15.818 33.637L14.104 39.637C14.042 39.852 13.846 40 13.623 40Z",
    fill: "#E3A600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.377 40H37.337C37.669 40 37.909 39.682 37.818 39.363L36.104 33.363C36.042 33.148 35.846 33 35.623 33H32.663C32.331 33 32.091 33.318 32.182 33.637L33.896 39.637C33.958 39.852 34.154 40 34.377 40Z",
    fill: "#E3A600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12C39 10.343 37.657 9 36 9H27C25.344 9 24 10.343 24 12V26H39V12Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 10.343 22.657 9 21 9H12C10.344 9 9 10.343 9 12V26H24V12Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 29H9V25C9 23.896 9.896 23 11 23H37C38.104 23 39 23.896 39 25V29Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 35H8C5.791 35 4 33.209 4 31V18C4 17.448 4.448 17 5 17H8C8.552 17 9 17.448 9 18V35Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M36.104 33.363C36.042 33.148 35.846 33 35.623 33H32.663C32.331 33 32.091 33.318 32.182 33.637L32.857 36H36.857L36.104 33.363Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M36.104 33.363C36.042 33.148 35.846 33 35.623 33H32.663C32.331 33 32.091 33.318 32.182 33.637L32.714 35.5H36.714L36.104 33.363Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.916 33.363C11.977 33.148 12.174 33 12.397 33H15.357C15.689 33 15.929 33.318 15.838 33.637L15.163 36H11.163L11.916 33.363Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M11.916 33.363C11.977 33.148 12.174 33 12.397 33H15.357C15.689 33 15.929 33.318 15.838 33.637L15.305 35.5H11.305L11.916 33.363Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43 17H40C39.448 17 39 17.448 39 18V29H4V31C4 33.209 5.791 35 8 35H40C42.209 35 44 33.209 44 31V18C44 17.448 43.552 17 43 17Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 17.5,
    x2: 39,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7819A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771AA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9,
    y1: 17.5,
    x2: 24,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7819A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771AA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9,
    y1: 26,
    x2: 39,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC4AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4,
    y1: 26,
    x2: 9,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 4,
    y1: 26,
    x2: 44,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge);
export default __webpack_public_path__ + "static/media/lounge.acfcd795e2abc8b7ad63114e90ec179c.svg";
export { ForwardRef as ReactComponent };